import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzInputModule} from 'ng-zorro-antd/input';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {AIInputComponent} from 'app/common/ai-input/ai-input.component';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {AIProductComponent} from 'app/common/ai-input/ai-product.component';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {SatPopoverModule} from '@ncstate/sat-popover';
import {NzEmptyModule} from 'ng-zorro-antd/empty';
import {NzFormModule} from 'ng-zorro-antd/form';
import {MposEntityModule} from 'app/common/mpos-entity/mpos-entity.module';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {SpeechmaticsModelService} from 'app/blocks/service/speech/speechmatics-model.service';
import {DefaultSpeechModelService} from 'app/blocks/service/speech/default-speech-model.service';
import {MposFormsModule} from 'app/common/mpos-forms/mpos-forms.module';

@NgModule({
    declarations: [AIInputComponent, AIProductComponent],
    imports: [
        CommonModule,
        TranslateModule,
        NzIconModule,
        NzInputModule,
        FontAwesomeModule,
        NzToolTipModule,
        FormsModule,
        ReactiveFormsModule,
        SatPopoverModule,
        NzEmptyModule,
        NzFormModule,
        MposEntityModule,
        FontAwesomeModule,
        NzTabsModule,
        MposFormsModule
    ],
    exports: [AIInputComponent, AIProductComponent],
    providers: [SpeechmaticsModelService, DefaultSpeechModelService]
})
export class AIInputModule {}
